// src/mixins/clickMixin.js
export default {
    methods: {
        isAssetEmail(item) {
          return (this.isAsset(item) && item.module === 'email');
        },
    
        isAssetEmailTemplate(item) {
            return (this.isAsset(item) && item.module === 'emailTemplate');
        },
    
        isAssetLandingPage(item) {
            return (this.isAsset(item) && item.module === 'landingPage');
        },
    
        isAssetLandingPageTemplate(item) {
            return (this.isAsset(item) && item.module === 'landingPageTemplate');
        },
    
        isAssetSnippet(item) {
            return (this.isAsset(item) && item.module === 'snippet');
        },
    
        isAssetRoot(item) {
            return (item.folderType === 'Zone' && item.parent_key == null);
        },
    
        isAssetWorkspace(item) {
            return (item.folderType === 'Zone' && item.parent_key != null);
        },
    
        isAsset(item) {
            return item.type !== 'folder';
        },
    
    }
};
